// dev-requests-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A descrição ficou grande demais. Resuma o texto ou tente anexar a imagem de novo.": "La descripción quedó demasiado grande. Resuma el texto o intente adjuntar la imagen de nuevo.",
    "A confirmação expirou. Tente de novo.": "La confirmación expiró. Inténtelo de nuevo.",
    "Cadastrar digital ou PIN": "Registrar huella o PIN",
    "Cadastre sua digital primeiro.": "Registre su huella primero.",
    "Confirmação cancelada.": "Confirmación cancelada.",
    "Digital ou PIN cadastrado.": "Huella o PIN registrado.",
    "Enviado ao robô": "Enviado al robot",
    "Enviar ao robô": "Enviar al robot",
    "Enviar ao robô?": "¿Enviar al robot?",
    "Esta conta ainda não pode enviar ao robô. Fale com o desenvolvedor.": "Esta cuenta aún no puede enviar al robot. Hable con el desarrollador.",
    "Esta conta já tem digital ou PIN cadastrado.": "Esta cuenta ya tiene huella o PIN registrado.",
    "Este navegador não aceita digital nem PIN. Use Chrome, Edge ou Safari atualizados.": "Este navegador no acepta huella ni PIN. Use Chrome, Edge o Safari actualizados.",
    "Este pedido já foi enviado ao robô.": "Este pedido ya fue enviado al robot.",
    "Imagem %{n}": "Imagen %{n}",
    "Não foi possível cadastrar a digital ou o PIN.": "No fue posible registrar la huella o el PIN.",
    "Não foi possível confirmar a digital ou o PIN.": "No fue posible confirmar la huella o el PIN.",
    "O pedido mudou, recarregue a página": "El pedido cambió, recargue la página",
    "O robô vai ler exatamente isto. Se tiver algo que você não escreveu, não envie.": "El robot va a leer exactamente esto. Si hay algo que usted no escribió, no lo envíe.",
    "O pedido só pode ser editado enquanto está pendente.": "El pedido solo se puede editar mientras está pendiente.",
    "Para falar com o robô, esta conta precisa de digital ou PIN e da liberação do desenvolvedor.": "Para hablar con el robot, esta cuenta necesita huella o PIN y la autorización del desarrollador.",
    "Pedido enviado ao robô.": "Pedido enviado al robot.",
    "Rascunho": "Borrador",
    "Este pedido ainda não foi enviado. O robô só começa depois de Enviar ao robô.": "Este pedido aún no fue enviado. El robot solo empieza después de Enviar al robot.",
    "Rascunho salvo. Confira o texto e confirme o envio.": "Borrador guardado. Revise el texto y confirme el envío.",
    "Ativa": "Activa",
    "Trabalhando": "Trabajando",
    "Parada": "Detenida",
    "Trabalhando no pedido #%{n} desde %{hora}": "Trabajando en el pedido #%{n} desde las %{hora}",
    "Última verificação às %{hora} (%{ago})": "Última verificación a las %{hora} (%{ago})",
    "Ainda não rodou": "Aún no se ejecutó",
    "Verifica a cada 1 min": "Verifica cada 1 min",
    "Respostas, aprovações e reaberturas a cada 5 min": "Respuestas, aprobaciones y reaperturas cada 5 min",
    "Verifica de hora em hora, na hora cheia": "Verifica cada hora, en punto",
    "O robô roda no Mac do desenvolvedor: Mac desligado ou dormindo para a fila.": "El robot corre en el Mac del desarrollador: con el Mac apagado o en reposo, la cola se detiene.",
    "Filas do robô": "Colas del robot",
    "Só o desenvolvedor libera esta etapa.": "Solo el desarrollador libera esta etapa.",
    "Só o desenvolvedor pode liberar esta etapa.": "Solo el desarrollador puede liberar esta etapa.",
};

export default catalogo;
